export default {
  genres: 'Géneros',
  artists: 'Artistas',
  albums: 'Álbumes',
  tracks: 'Temas',
  playlist: 'Lista',
  playlists: 'Listas',
  unknown_artist: 'Artista desconocido',
  unknown_album: 'Álbum desconocido',
  unknown_track: 'Pista desconocida',
  unknown_playlist: 'Lista desconocida',

  browser_no_support: 'Este navegador no tiene soporte para audio HTML.',

  playlist_prompt: 'Nombre de la lista (username:playlist_name)',
  random_playlist: 'Lista aleatória',
  all_apologies: 'Disculpen las molestias. Esto no funciona aun',

  artists_alphabet: 'A-Z',
  recent_artists: 'Recientemente añadido',
}